
























import PrefixLastStats from "@/components/PrefixLastStats.vue";
import PrefixSubPrefixes from "@/components/PrefixSubPrefixes.vue";
import TimeRangeControls from "@/components/TimeRangeControls.vue";
import { Prefix } from "@/types/debug-mode";
import { Series, SeriesPoint } from "@/types/common";
import { getTitle } from "@/utils/chart";
import GetPrefixStats from "@/mixins/get-prefix-stats";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    PrefixLastStats,
    PrefixSubPrefixes,
    TimeRangeControls,
  },
})
export default class PrefixOverview extends Mixins(GetPrefixStats) {
  created() {
    if (this.prefix.id) {
      this.getPrefixStats(this.prefix.id);
    }
  }

  beforeDestroy() {
    this.cleanUpPrefixStats();
  }

  @Getter("debugMode/activePrefix") prefix!: Prefix;
  @Getter("debugMode/prefixStatsSeries") series!: (chartID: string) => false | Series;
  @Getter("debugMode/prefixLastStats") lastStats!: (chartID: string) => SeriesPoint | null | false;

  @Watch("prefix")
  onPrefixUpdate() {
    this.getPrefixStats(this.prefix.id);
  }

  chartIDs: string[] = [
    "prefixHitRate",
    "prefixRelativeActivity",
    "prefixHitsMissesMutations",
    "prefixHitsMissesMutationsRate",
  ];

  chartTitle(chartID: string): string {
    return getTitle(chartID);
  }
}
